import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {SystemUser} from '../../shared/Models/SystemUser';
import {ChangePassword} from '../Models/ChangePassword';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class DealerUserService {
  constructor(private helper: Helper, private http: HttpClient, private cookieService: CookieService) {
  }

  public getUserEmployee(gridData = new HttpParams(), params = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/user/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getUserRoles(scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/user/roles')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageUser(user: SystemUser, isEdit, id = null) {
    if (isEdit) {
      return this.http.put<any>(environment.apiUrl + '/dealer-system/user/' + id, user)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post<any>(environment.apiUrl + '/dealer-system/user/', user)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteDealerUser(id) {
    return this.http.delete(environment.apiUrl + '/dealer-system/user/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAddDealerUser(id) {
    return this.http.put(environment.apiUrl + '/dealer-system/user/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public changePassword(params: ChangePassword) {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + btoa(this.cookieService.get('username') + ':' + params.currentPassword));
    return this.http.post(
      environment.apiUrl + '/users/change-password',
      {password: params.password, passwordConfirmation: params.passwordConfirmation},
      {'headers': headers}
    );
  }

  public manageAllowPartialOrder(isAllowedPartialPaid, id) {
    return this.http.put(environment.apiUrl + '/dealer-system/user/' + id + '/edit-allow-partial-order', {isAllowedPartialPaid: isAllowedPartialPaid})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
